import React from "react";

import firstExco from "../../assests/history/first_ex_co_at_agm.webp";
import obaOffice from "../../assests/history/oba_office.JPG";

export default function OBAHistoryComponent() {
  // History data
  const historyData = {
    images: [
      {
        src: firstExco,
        alt: "Historical photo of OBA founding members",
        caption:
          "Founding members at the inaugural Annual General Meeting - 1953",
      },
      {
        src: obaOffice,
        alt: "The Office of OBA",
        caption: "The Office of the Old Boys' Association",
      },
    ],
  };
  return (
    <section
      className="mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-right"
      id="history"
    >
      <div className="rounded-3 border-vcg-muted p-4">
        <h3 className="fw-bold mb-4">History of the Old Boys' Association</h3>

        <div className="row align-items-center">
          {/* History Text */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <p className="text-secondary mb-3" style={{ textAlign: "justify" }}>
              According to historical records, the earliest documented reference
              to the Old Boys’ Association of Vidyaloka College dates back to
              1953. This is evidenced by a preserved group photograph taken at
              the Annual General Meeting held in that year, which stands as the
              oldest written and visual record of the Association’s existence.
              <br />
              <br />
              In 1965, the Old Boys’ Association was formally reestablished
              under the leadership of several prominent and respected figures in
              the history of Vidyaloka College, including Mr. Henry Gunasinghe,
              Mr. Shriyananda Salvathura, Mr. Bennet Senevirathne, Mr. J A
              Jinadasa, Mr. P C Silva, Mr. Dougles Mudalige, Mr. Daya
              Muthukumarana, Mr. C Abeygunawardena, Mr. M H H Ariyadasa, Mr.
              Premachandra Denipitiya, Mr. H W Dissanayake, and Mr. Dharmasena
              Dias. Their initiative marked a significant turning point in
              shaping the Association into a structured and organized body. An
              Executive Committee was formed during this period, with the
              Principal of Vidyaloka College, Mr. B K Silva, serving as the
              President. The committee also included Mr. C Abeygunawardena as
              Secretary and Mr. Shriyananda Salvathura as Treasurer, ensuring
              effective administration and continuity.
              <br />
              <br />
              One of the key achievements of this reestablishment was the
              introduction of a formal membership structure. Life membership was
              established with an initial fee of Rs. 25, while the annual
              membership fee was set at Rs. 2. These contributions formed the
              foundation of the Association’s financial stability during its
              early years.
              <br />
              <br />
              During this period, the Development Fund of the Old Boys’
              Association was established and deposited at the National Savings
              Bank. This fund, which remains active to this day, was initially
              built solely through membership contributions. To further
              strengthen the Development Fund, many generous past students of
              Vidyaloka College came forward with voluntary donations,
              demonstrating their commitment and loyalty to the school.
              <br />
              <br />
              In the early stages, operational expenses such as stationery and
              printing costs were generously borne by Mr. Bennet Senevirathne,
              the proprietor of the Galle Merchant Print House, whose support
              played a vital role in sustaining the Association’s activities
              during its formative years.
              <br />
              <br />
              In 1982, a notable tradition was introduced with the luncheon held
              following the Annual General Meeting. This event was first
              organized under the patronage of senior old boys, including Mr.
              Shelton Gamage and Mr. Gunasoma, with former teachers, current
              teachers, and past students invited to participate.
              <br />
              <br />
              12 February 1995 was a memorable and significant day for the Old
              Boys’ Association of Vidyaloka College. On this occasion, the
              Association had the honour of hosting several distinguished past
              students at a special welcoming ceremony. Among the eminent guests
              were the Honourable Minister of Education and Higher Education,
              Dr. Richard Pathirana, the Honourable Member of Parliament, Mr.
              Nanda Gunasinghe, and the Honourable Vice Chancellor of the
              University of Sri Lanka (now University of Colombo), Senior Prof.
              W D Lakshman.
              <br /> <br />
              In 1987, a building was generously donated to the school by Mr.
              Ananda Ganegoda, a distinguished old boy and the proprietor of
              Trans Lanka. In recognition of this contribution, the building was
              officially named the Ananda Ganegoda Library. On the same
              occasion, the Buddha Statue donated by Mr. Gunasoma Gamage and his
              family was formally declared open.
              <br />
              <br />
              During the visit in 1995, the Honourable Minister of Education and
              Higher Education pledged to initiate the necessary formalities to
              declare Vidyaloka College as a National School. Later, the
              Government of Sri Lanka officially declared Vidyaloka College a
              National School on 18 August 1995.
              <br />
              <br />
              Through periods of both progress and challenge, Mr. W. M.
              Jagathchandra, who served as Secretary from 1982, played a pivotal
              role in guiding the Old Boys’ Association along a new and stable
              path. Working with clear vision, accurate records, and sound
              financial management, he contributed significantly to
              strengthening the foundation of the Association.
              <br />
              <br />
              In 1999, a major milestone was achieved with the amendment of the
              Constitution of the Old Boys’ Association, making it more robust
              and structured. As part of these reforms, the governing framework
              was revised. Since then, by virtue of office, the Principal of
              Vidyaloka College serves as the President of the Executive
              Committee, while the Active President leads the Executive
              Committee, working in close collaboration with the executive
              officers and committee members. This structure ensures adherence
              to the Constitution while serving the best interests of both the
              school and its past students.
            </p>
          </div>

          {/* History Images */}
          <div className="col-lg-6 ">
            <div className="row g-4 justify-content-center">
              {historyData.images.map((image, index) => (
                <div
                  key={index}
                  className="d-flex flex-column justify-content-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="rounded-3"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                  {image.caption && (
                    <p className="text-center text-muted mt-2 small">
                      {image.caption}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
